<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="质检时间">
          <el-date-picker
            v-model="searchForm.date"
            unlink-panels
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyyMMdd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="店铺">
          <el-select v-model="searchForm.storeNameList" filterable multiple collapse-tags clearable @change="storeChange">
            <el-option v-show="!all" label="全部" value=""></el-option>
            <el-option v-show="all" label="取消所有" value="cancleAll"></el-option>
            <el-option v-for="item in storeList" :label="item.storeName" :key="item.storeCode" :value="item.storeName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="违规项">
          <el-select v-model="searchForm.violationList" filterable multiple collapse-tags clearable @change="categoryDetailChange">
            <el-option v-show="!all3" label="全部" value=""></el-option>
            <el-option v-show="all3" label="取消所有" value="cancleAll"></el-option>
            <el-option v-for="item in categoryDetailList" :label="item" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="岗位">
          <el-select v-model="searchForm.workJobsList" filterable multiple collapse-tags clearable @change="workJobsChange">
            <el-option v-show="!all2" label="全部" value=""></el-option>
            <el-option v-show="all2" label="取消所有" value="cancleAll"></el-option>
            <el-option v-for="item in workJobsList" :label="item" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
      </template>
    </search-box>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.records"
        :height="maxTableHeight + 42"
        :span-method="arraySpanMethod"
        @sort-change="handleSortChange"
        v-if="tableReload"
        v-loading="loading"
      >
        <!-- 二级表头 -->
        <el-table-column
          :label="item.label"
          :prop="item.prop"
          :fixed="item.fixed"
          :min-width="item.width"
          :show-overflow-tooltip="item.label != '违规项'"
          v-for="(item,index) in columnData"
          :sortable="index > 1 ? 'custom' : false"
          :key="item.prop"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row[item.prop] }}
          </template>
        </el-table-column>
      </el-table>
    </table-panel>
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import axios from "@/utils/axiosInstance";
import moment from "moment";
export default {
  name: "jobDataAnalysis",
  mixins: [tableMixin],
  components: {},
  data() {
    return {
      loading: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "goodsCheckInfoReport",
      columnData: [],
      storeList: [],
      categoryDetailList: [],
      workJobsList: ["售前客服", "售中客服", "售后客服"],
      loading: false,
      searchForm: {
        date: [moment().subtract(1,'week').startOf('week').format('YYYYMMDD'), moment().subtract(1,'week').endOf('week').format('YYYYMMDD')],
        storeName: "",
        billStatusDesc: "",
        sendStatus: "",
      },
      exportData: {},
      orderSort: {},
      searchCollapse: false,
      all: false,
      all2: false,
      all3: false,
      defaultStroe: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.getStoreList();
    this.getCategoryDetailList();
  },
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.$refs.tableRef.clearSort();
      this.orderSort = {}
      this.tableData.pageNum = 1;
      this.init();
    },
    async init(type) {
      this.loading = true;
      let data = {
        startDate: this.searchForm.date && this.searchForm.date.length ? this.searchForm.date[0] : "",
        endDate: this.searchForm.date && this.searchForm.date.length ? this.searchForm.date[1] : "",
        ...this.searchForm,
        ...this.orderSort
      };
      this.searchFormData = data;
      this.$q.qualityTestingManage
        .violationRatioSearch({ data: data })
        .then((res) => {
          this.columnData = []
          res.data.titleList.forEach((v) => {
            this.columnData.push({
              label: v.titleName,
              prop: v.propertyName,
              width: v.displayWidth,
              sortable: v.sortable == "1" ? "custom" : false,
              span: false,
              fixed: v.fixed == 1 ? "left" : false,
            });
          });
          this.tableData = res.data.dynamicData;
        })
        .finally((_) => {
          this.loading = false;
        });
    },

    reset() {
      this.searchForm = {
        date: [moment().subtract(1,'week').startOf('week').format('YYYYMMDD'), moment().subtract(1,'week').endOf('week').format('YYYYMMDD')],
        storeName: "",
        billStatusDesc: "",
        sendStatus: "",
        storeNameList: this.defaultStroe
      };
      this.all = false
      this.all2 = false
      this.all3 = false
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    storeChange(val) {
      this.all = this.storeList.length == val.length;
      if (val.includes("")) {
        this.searchForm.storeNameList = this.storeList.map((v) => v.storeName);
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.storeNameList = [];
        this.all = false;
      }
    },
    workJobsChange(val) {
      this.all2 = this.workJobsList.length == val.length;
      if (val.includes("")) {
        this.searchForm.workJobsList = this.workJobsList;
        this.all2 = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.workJobsList = [];
        this.all2 = false;
      }
    },
    categoryDetailChange(val) {
      this.all3 = this.categoryDetailList.length == val.length;
      if (val.includes("")) {
        this.searchForm.violationList = this.categoryDetailList;
        this.all3 = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.violationList = [];
        this.all3 = false;
      }
    },
    //店铺
    getStoreList() {
      this.loading = true
      let data = { ...this.currencyForm };
      data.reportCode = "storeInfoList";
      axios.post(`/ec-pc-api/custom/reports/data/storeInfoList`, data).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list;
          let defaultStroe = this.storeList.filter(v=>['天猫一店','京东一店','天猫二店','京东二店','京东美学'].includes(v.storeName)).map(v=>v.storeName)
          this.defaultStroe = defaultStroe
          this.$set(this.searchForm,'storeNameList',defaultStroe)
          this.storeChange(defaultStroe)
          this.onSearch();
        }
      });
    },
    //违规项
    getCategoryDetailList() {
      let data = { ...this.currencyForm };
      data.reportCode = "qualityCheckProjectConfig";
      data.groupAttr = "categoryDetail";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.categoryDetailList = data;
      });
    },
    
    handleSortChange({ column, prop, order }) {
      this.tableData.pageNum = 1;
      this.orderSort = {
        sortField: prop,
        sortOptions:
          order === "ascending" ? "0" : order === "descending" ? "1" : "",
      }
      this.init();
    },
    flitterData(arr) {
      let spanOneArr = [];
      let concatOne = 0;
      if (arr) {
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            if (item.workJobs === arr[index - 1].workJobs) {
              //第一列需合并相同内容的判断条件
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
      } else {
        spanOneArr = [];
      }

      return spanOneArr;
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (!row.workJobs && row.violation == '合计') {
        if (columnIndex === 0) {
            return [0, 0];
          } else if (columnIndex === 1) {
            return [1, 2];
          }
          // return [1, 2];
      }
      if (columnIndex === 0) {
        const _row = this.flitterData(this.tableData.records)[rowIndex];
        const _col = _row > 0 && _row ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
    // 导出
    async exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$q.qualityTestingManage.violationRatioExport({ data: this.searchFormData, options: { responseType: "blob" } }).then((res) => {
        let fileName = "违规占比" + moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        this.blobDownload(res, `${fileName}.xlsx`);
      }).finally(_=>{
        loading.close();
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .search-outer>div
  padding 0
>>> .el-select__tags-text {
display: inline-block;
max-width: 60px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
